import api from '@/api'
const {$core} = api
const $st = api.$student
export const {$configuration} = $core
export const {$student} = $st
